import { render, staticRenderFns } from "./ApiRateLimitModal.vue?vue&type=template&id=6054904a&scoped=true"
import script from "./ApiRateLimitModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApiRateLimitModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ApiRateLimitModal.vue?vue&type=style&index=0&id=6054904a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054904a",
  null
  
)

export default component.exports